module.exports = __webpack_public_path__ + "img/basme.4b3b975e.jpg";